import { getFillByLot } from "../manzanas/Manzana2Div1";

export const Manzana46Div8M2 = ({
  lands,
  landSelector = (_e, _id) => {},
  selected,
  style,
}) => {
  const findLandByLot = (lot) => {
    return lands.filter((l) => l.lote === lot)[0];
  };

  if (!lands) {
    return <></>;
  }

  return (
    <svg 
    width={style?.width || "1219"}
    height={style?.height || "941"}
    viewBox="0 0 1221 921" 
    fill="none" 
    xmlns="http://www.w3.org/2000/svg">
    <rect width="1215" height="921" fill="url(#pattern0_1443_2368)"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}      
      d="M768.418 586.535L777.765 608.735L712.332 639.115L692.469 612.241L743.88 563.166L768.418 586.535Z" 
      fill={getFillByLot(1, selected, lands)} 
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}      
      d="M658.588 579.523L692.473 612.239L743.885 563.164L710 529.279L658.588 579.523Z" 
      fill={getFillByLot(1, selected, lands)} 
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}      
      d="M627.031 545.636L658.579 579.521L709.991 529.278L678.442 495.393L627.031 545.636Z" 
      fill={getFillByLot(1, selected, lands)} 
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}      
      d="M593.148 512.923L627.033 545.639L678.445 495.396L645.728 462.68L593.148 512.923Z" 
      fill={getFillByLot(1, selected, lands)} 
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}      
      d="M560.437 480.205L593.154 512.921L645.734 462.678L614.186 428.793L560.437 480.205Z" 
      fill={getFillByLot(1, selected, lands)} 
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}      
      d="M534.732 452.165L560.437 480.207L614.186 428.796L575.627 389.068L534.732 452.165Z" 
      fill={getFillByLot(1, selected, lands)} 
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}      
      d="M521.877 443.983L534.73 452.162L575.626 389.066L549.92 365.697L512.53 371.54L521.877 443.983Z" 
      fill={getFillByLot(1, selected, lands)} 
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}      
      d="M476.308 449.825L521.877 445.151L512.53 371.539L465.792 378.55L476.308 449.825Z" 
      fill={getFillByLot(1, selected, lands)} 
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}      
      d="M429.567 455.666L476.304 449.824L465.788 378.549L420.219 384.391L429.567 455.666Z" 
      fill={getFillByLot(1, selected, lands)} 
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}      
      d="M384.005 462.677L429.575 455.666L420.227 384.391L374.658 390.233L384.005 462.677Z" 
      fill={getFillByLot(1, selected, lands)} 
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}      
      d="M329.078 397.247L374.647 390.236L383.995 462.68L338.425 469.691L329.078 397.247Z" 
      fill={getFillByLot(1, selected, lands)} 
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}      
      d="M292.857 476.701L338.426 469.69L329.079 397.246L283.509 403.088L292.857 476.701Z" 
      fill={getFillByLot(1, selected, lands)} 
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}      
      d="M247.287 482.542L292.857 476.7L283.509 403.088L236.771 410.099L247.287 482.542Z" 
      fill={getFillByLot(1, selected, lands)} 
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}      
      d="M201.722 488.386L247.292 482.543L236.776 410.1L192.375 417.11L201.722 488.386Z" 
      fill={getFillByLot(1, selected, lands)} 
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}      
      d="M156.152 495.397L201.721 488.387L192.374 417.111L146.804 424.122L156.152 495.397Z" 
      fill={getFillByLot(1, selected, lands)} 
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}      
      d="M104.741 503.576L156.153 495.396L146.805 424.121L122.268 425.29L90.7197 489.554L104.741 503.576Z" 
      fill={getFillByLot(1, selected, lands)} 
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <defs>
    <pattern id="pattern0_1443_2368" patternContentUnits="objectBoundingBox" width="1" height="1">
    <use href="#image0_1443_2368" transform="matrix(0.00161063 0 0 0.00212478 -3.61532 -2.61651)"/>
    </pattern>
    <image id="image0_1443_2368"  width="4096" height="2304" href="/mz2.png"/>
    </defs>
    </svg>

  );
};